import { Box, Text } from '@chakra-ui/react'

export const CountBadgeAccordion = ({ text }: { text: string | number }) => (
  <Box backgroundColor='brand.200' borderRadius='20px' px='10px' py='2px'>
    <Text color='white' fontSize='14px'>
      {text}
    </Text>
  </Box>
)
